import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`relation?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`relation/${id}`);
    },
    create(data) {
        return Api().post(`relation`, data);
    },
    update(data) {
        return Api().put(`relation/${data.id}`, data);
    },
    delete(id) {
        return Api().delete(`relation/${id}`);
    },
}